// extracted by mini-css-extract-plugin
module.exports = {"tour":"a10a3f92e9--tour--cFULP","title":"a10a3f92e9--title--BAGdF","content":"a10a3f92e9--content--G9RjV","layout":"a10a3f92e9--layout--iJ70z","text":"a10a3f92e9--text--uVmYo"};